import api from './api';

export interface Slider {
    id: string;
    title: string;
    subtitle?: string;
    image_url: string;
    link_url?: string;
    link_type?: string;
    link_target?: string;
    display_order: number;
    is_active: boolean;
    start_date?: string;
    end_date?: string;
    created_at?: string;
    updated_at?: string;
}

export interface CreateSliderRequest {
    title: string;
    subtitle?: string;
    image_url: string;
    link_url?: string;
    link_type?: string;
    link_target?: string;
    display_order: number;
    is_active: boolean;
    start_date?: string;
    end_date?: string;
}

export interface UpdateSliderRequest {
    title: string;
    subtitle?: string;
    image_url: string;
    link_url?: string;
    link_type?: string;
    link_target?: string;
    display_order: number;
    is_active: boolean;
    start_date?: string;
    end_date?: string;
}

interface ApiResponse<T> {
    success: boolean;
    data: T;
    meta?: any;
    error?: any;
}

const sliderService = {
    getAll: async (activeOnly: boolean = false): Promise<Slider[]> => {
        const response = await api.get<ApiResponse<Slider[]>>('/sliders', {
            params: { active_only: activeOnly }
        });
        return response.data.data || [];
    },

    getById: async (id: string): Promise<Slider> => {
        const response = await api.get<ApiResponse<Slider>>(`/sliders/${id}`);
        return response.data.data;
    },

    create: async (data: CreateSliderRequest): Promise<Slider> => {
        const response = await api.post<ApiResponse<Slider>>('/sliders', data);
        return response.data.data;
    },

    update: async (id: string, data: UpdateSliderRequest): Promise<Slider> => {
        const response = await api.put<ApiResponse<Slider>>(`/sliders/${id}`, data);
        return response.data.data;
    },

    delete: async (id: string): Promise<void> => {
        await api.delete<ApiResponse<any>>(`/sliders/${id}`);
    },

    uploadImage: async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append('image', file);
        const response = await api.post<ApiResponse<{ url: string }>>('/sliders/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data.url;
    }
};

export default sliderService;
